module.exports = __webpack_public_path__ + "img/gallery-img-2.5443d4d1.jpg";